import { UserCredentials } from '../services/wpAuth';

/**
 * Retrieves stored user credentials from localStorage
 * @returns UserCredentials object or null if not found/invalid
 */
export const getStoredCredentials = (): UserCredentials | null => {
    try {
        const storedCredentials = localStorage.getItem("user_credentials");
        if (!storedCredentials) {
            return null;
        }
        return JSON.parse(storedCredentials) as UserCredentials;
    } catch (error) {
        console.error("Failed to parse stored credentials:", error);
        // Clear invalid credentials
        localStorage.removeItem("user_credentials");
        return null;
    }
};

/**
 * Stores user credentials in localStorage
 * @param credentials The user credentials to store
 */
export const storeCredentials = (credentials: UserCredentials): void => {
    try {
        localStorage.setItem("user_credentials", JSON.stringify(credentials));
    } catch (error) {
        console.error("Failed to store credentials:", error);
    }
};

/**
 * Removes stored user credentials from localStorage
 */
export const clearStoredCredentials = (): void => {
    localStorage.removeItem("user_credentials");
};

/**
 * Checks if user is authenticated (has valid stored credentials)
 * @returns boolean indicating if user is authenticated
 */
export const isAuthenticated = (): boolean => {
    return getStoredCredentials() !== null;
};
